import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";

import { useState, useEffect, useContext } from "react";
import { notification, Spin } from "antd";
import TradesTable from "./TradesTable";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import { ServiceContext } from "src/services/provider/Service.provider";

function GerencialOperacoesList(props: RouteComponentProps<any>) {
  const { tradeService } = useContext(ServiceContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch();
  }, []);

  async function fetch(params = {}) {
    setLoading(true);

    try {
      const trades = await tradeService.getAllOperations();
      setData(trades);
    } catch (error) {
      notification.error({
        message: "Falha na consulta",
        description: "Ocorreu um erro durante a consulta. Tente novamente."
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Spin spinning={loading}>
      <PbrCard title="Operações Realizadas" bordered={false} style={{ width: "100%" }}>
        <TradesTable data={data} loading={loading} refresh={fetch} />
      </PbrCard>
    </Spin>
  );
}

export default withRouter(GerencialOperacoesList);



// WEBPACK FOOTER //
// ./src/pages/gerencial/operacoes/trades/GerencialOperacoesList.tsx